import { toast } from "react-toastify";

import apiClient from "../api-client.js";
import { withAgencyParam } from "../utils/urlHelpers.js";

/** Uploads an image to embed in a piece's Markdown; its URL, or null after showing the error. */
export const uploadInlineImage = async (configId, file) => {
  const formData = new FormData();
  formData.append("image", file);
  try {
    const { data } = await apiClient.post(`/content-generation/configs/${configId}/inline_image/`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 30000,
    });
    return data.url;
  } catch (error) {
    toast.error(error.response?.data?.detail || "No se ha podido subir la imagen.");
    return null;
  }
};

// Content prompts (GenerationAIConfig), one config per agency.
export const aiConfigEndpoint = (agencyId) => withAgencyParam("content-generation/ai-config/", agencyId);

/** Same key shape as getData, so the settings page and every "Configurar prompts" share one cache entry. */
export const aiConfigQueryKey = (agencyId) => ["getData", aiConfigEndpoint(agencyId), 0];

export const fetchAiConfig = (agencyId) => apiClient.get(aiConfigEndpoint(agencyId)).then((response) => response.data);

/** Resolves to the updated config. */
export const updateAiConfig = (agencyId, changes) =>
  apiClient
    .patch(withAgencyParam("content-generation/ai-config/update/", agencyId), changes)
    .then((response) => response.data);
